import Container from "../../styles/container";
import { StyledRegister, TextSection } from "./styles";
import StyledLogo from "../../components/Logo/styles";
import { LinkButton, FormButton } from "../../components/Button";
import { StyledForm, StyledAlert } from "../../components/Form/styles";
import { UserContext } from "../../contexts/UserContext";
import { motion } from "framer-motion";

import { useContext } from "react";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { MdErrorOutline } from "react-icons/md";

interface IUserRegister {
  id: string;
  name: string;
  email: string;
  course_module: string;
  bio: string;
  contact: string;
  password: string;
  confirmPassword: string;
  techs: ITechs[];
}

interface ITechs {
  id: string;
  title: string;
  status: string;
}

const Register = () => {
  const { handleRegister } = useContext(UserContext);

  const schema = yup.object({
    name: yup.string().required("Campo obrigatório"),
    email: yup.string().email("Email inválido").required("Campo obrigatório"),
    password: yup
      .string()
      .matches(/[A-Z]/, " Sua senha deve conter ao menos 1 letra maiúscula")
      .matches(/([a-z])/, "Sua senha deve conter ao menos 1 letra minúscula")
      .matches(/(\d)/, "Sua senha deve conter ao menos 1 número")
      .matches(/(\W)|_/, "Sua senha deve conter ao menos 1 caracter especial")
      .matches(/.{8}/, "Sua senha deve conter ao menos 8 dígitos"),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "As senhas devem ser iguais"),
    bio: yup.string().required("Campo obrigatório"),
    contact: yup.string().required("Campo obrigatório"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IUserRegister>({
    resolver: yupResolver(schema),
  });

  return (
    <motion.div
      initial={{ opacity: 0, originY: 0.5 }}
      animate={{ opacity: 1, originY: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Container>
        <StyledRegister>
          <header>
            <StyledLogo>Kenzie Hub</StyledLogo>
            <LinkButton
              buttonSize={"medium"}
              buttonStyle={"medium-style"}
              link={"/"}
            >
              Voltar
            </LinkButton>
          </header>
          <main>
            <TextSection>
              <h3>Crie sua conta</h3>
              <span>Rápido e grátis, vamos nessa</span>
            </TextSection>
            <StyledForm onSubmit={handleSubmit(handleRegister)}>
              <label htmlFor="name">Nome</label>
              <div className="inputContent">
                <input
                  type="text"
                  id="name"
                  placeholder="Digite aqui seu nome"
                  {...register("name")}
                />
                {errors.name && (
                  <StyledAlert>
                    <MdErrorOutline />
                    <p> {errors.name.message} </p>
                  </StyledAlert>
                )}
              </div>
              <label htmlFor="email">Email</label>
              <div className="inputContent">
                <input
                  type="text"
                  id="email"
                  placeholder="Digite aqui seu email"
                  {...register("email")}
                />
                {errors.email && (
                  <StyledAlert>
                    <MdErrorOutline />
                    <p> {errors.email.message} </p>
                  </StyledAlert>
                )}
              </div>
              <label htmlFor="password">Senha</label>
              <div className="inputContent">
                <input
                  type="password"
                  id="password"
                  placeholder="Digite aqui sua senha"
                  {...register("password")}
                />
                {errors.password && (
                  <StyledAlert>
                    <MdErrorOutline />
                    <p> {errors.password.message} </p>
                  </StyledAlert>
                )}
              </div>
              <label htmlFor="confirm-password">Confirmar senha</label>
              <div className="inputContent">
                <input
                  type="password"
                  id="confirm-password"
                  placeholder="Digite novamente sua senha"
                  {...register("confirmPassword")}
                />
                {errors.confirmPassword && (
                  <StyledAlert>
                    <MdErrorOutline />
                    <p> {errors.confirmPassword.message} </p>
                  </StyledAlert>
                )}
              </div>
              <label htmlFor="bio">Bio</label>
              <div className="inputContent">
                <input
                  type="text"
                  id="bio"
                  placeholder="Fale sobre você"
                  {...register("bio")}
                />
                {errors.bio && (
                  <StyledAlert>
                    <MdErrorOutline />
                    <p> {errors.bio.message} </p>
                  </StyledAlert>
                )}
              </div>
              <label htmlFor="contact">Contato</label>
              <div className="inputContent">
                <input
                  type="text"
                  id="contact"
                  placeholder="Opção de contato"
                  {...register("contact")}
                />
                {errors.contact && (
                  <StyledAlert>
                    <MdErrorOutline />
                    <p> {errors.contact.message} </p>
                  </StyledAlert>
                )}
              </div>
              <label htmlFor="course_module">Selecionar módulo</label>
              <div className="inputContent">
                <select id="course_module" {...register("course_module")}>
                  <option value="first-module">Primeiro Módulo</option>
                  <option value="second-module">Segundo Módulo</option>
                  <option value="third-module">Terceiro Módulo</option>
                  <option value="fourth-module">Quarto Módulo</option>
                  <option value="fifth-module">Quinto Módulo</option>
                  <option value="sixth-module">Sexto Módulo</option>
                </select>
              </div>
              <FormButton
                link=""
                buttonSize="default"
                buttonStyle={"primary-disable"}
              >
                Cadastrar
              </FormButton>
            </StyledForm>
          </main>{" "}
        </StyledRegister>
      </Container>
    </motion.div>
  );
};

export default Register;
